export const ConsentCode = {
    MARKETING_RELATIONAL_COMMUNICATION: "marketing.relational-communication",
    MARKETING_COMMERCIAL_COMMUNICATION: "marketing.commercial-communication",
    MARKETING_PERSONAL_COMMUNICATION: "marketing.personal-communication",
} as const

export type ConsentCode = (typeof ConsentCode)[keyof typeof ConsentCode]
